{
  "familyId": "SWW-VD-KOF",
  "questions": [
    {
      "id": "SWW-VD-KOF-001",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De corrector schrijft: 'De hond heeft hard ...' (rennen). Welk woord past?",
      "options": ["gerend", "rent", "rende", "rennen"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "rennen", "stem": "ren", "lastLetter": "n", "useTE": false, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + d/t. De stam 'ren' eindigt op 'n' (niet in kofschip), dus: ge + ren + d = gerend.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_not_kofschip_n",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De corrector weet: na 'heeft' komt het voltooid deelwoord. De stam van 'rennen' is 'ren'. De laatste letter 'n' staat NIET in 't kofschip (T-K-O-F-S-CH-I-P), dus: ge + ren + d = gerend.",
        "solutionSteps": ["Na 'heeft' komt het voltooid deelwoord", "Stam bepalen: rennen → ren", "Laatste letter: 'n' → NIET in kofschip → +d", "ge + ren + d = gerend"],
        "distractorExplanations": {
          "0": "Goed! 'n' staat niet in kofschip → ge + stam + d = gerend.",
          "1": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar na 'heeft' komt altijd het voltooid deelwoord, niet de persoonsvorm. Onthoud: heeft/hebben + voltooid deelwoord.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar 'rende' is verleden tijd. Na 'heeft' gebruik je het voltooid deelwoord met ge-: gerend. Onthoud: heeft + ge-woord.",
          "3": "Je dacht waarschijnlijk dat het hele werkwoord hier past. Maar na 'heeft' komt het voltooid deelwoord: gerend, niet rennen. Onthoud: heeft + ge-woord."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-002",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De journalist schrijft: 'Ik heb de hele middag ...' (fietsen). Welk woord past?",
      "options": ["gefietst", "gefietsd", "fietste", "fiets"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "fietsen", "stem": "fiets", "lastLetter": "s", "useTE": true, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + t (bij kofschip). De stam 'fiets' eindigt op 's' (in kofschip), dus: ge + fiets + t = gefietst.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_kofschip_s",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De journalist weet: de stam van 'fietsen' is 'fiets'. De laatste letter 's' zit WEL in 't kofschip, dus: ge + fiets + t = gefietst.",
        "solutionSteps": ["Na 'heb' komt het voltooid deelwoord", "Stam bepalen: fietsen → fiets", "Laatste letter: 's' → WEL in kofschip → +t", "ge + fiets + t = gefietst"],
        "distractorExplanations": {
          "0": "Goed! 's' zit in kofschip → ge + stam + t = gefietst.",
          "1": "Je dacht waarschijnlijk dat het -d wordt. Maar de 's' in 'fiets' zit WEL in 't kofschip, dus +t, niet +d. Onthoud: kofschip-letter → +t.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar na 'heb' komt het voltooid deelwoord met ge-: gefietst, niet fietste. Onthoud: heb/heeft + ge-woord.",
          "3": "Je dacht waarschijnlijk dat de stam het antwoord is. Maar na 'heb' komt het voltooid deelwoord: gefietst, niet fiets. Onthoud: heb + ge-woord."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-003",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De schrijver noteert: 'Zij heeft het pakje ...' (pakken). Welk woord past?",
      "options": ["gepakt", "gepakd", "pakte", "gepakken"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "pakken", "stem": "pak", "lastLetter": "k", "useTE": true, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + t (bij kofschip). De stam 'pak' eindigt op 'k' (in kofschip), dus: ge + pak + t = gepakt.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_kofschip_k",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De schrijver weet: de stam van 'pakken' is 'pak'. De laatste letter 'k' zit WEL in 't kofschip (T-K-O-F-S-CH-I-P), dus: ge + pak + t = gepakt.",
        "solutionSteps": ["Na 'heeft' komt het voltooid deelwoord", "Stam bepalen: pakken → pak", "Laatste letter: 'k' → WEL in kofschip → +t", "ge + pak + t = gepakt"],
        "distractorExplanations": {
          "0": "Goed! 'k' zit in kofschip → ge + stam + t = gepakt.",
          "1": "Je dacht waarschijnlijk dat het -d wordt. Maar de 'k' in 'pak' zit WEL in 't kofschip, dus +t, niet +d. Onthoud: kofschip-letter → +t.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar na 'heeft' komt het voltooid deelwoord met ge-: gepakt, niet pakte. Onthoud: heeft + ge-woord.",
          "3": "Je dacht waarschijnlijk dat je ge- voor het hele werkwoord zet. Maar het voltooid deelwoord is ge + stam + t/d: gepakt, niet gepakken. Onthoud: ge + stam + t of d."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-004",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De redacteur leest: 'Wij hebben het huis ...' (bouwen). Welk woord past?",
      "options": ["gebouwd", "gebouwt", "bouwde", "gebouwen"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "bouwen", "stem": "bouw", "lastLetter": "w", "useTE": false, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + d (niet in kofschip). De stam 'bouw' eindigt op 'w' (niet in kofschip), dus: ge + bouw + d = gebouwd.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_not_kofschip_w",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De redacteur weet: de stam van 'bouwen' is 'bouw'. De laatste letter 'w' staat NIET in 't kofschip, dus: ge + bouw + d = gebouwd.",
        "solutionSteps": ["Na 'hebben' komt het voltooid deelwoord", "Stam bepalen: bouwen → bouw", "Laatste letter: 'w' → NIET in kofschip → +d", "ge + bouw + d = gebouwd"],
        "distractorExplanations": {
          "0": "Goed! 'w' staat niet in kofschip → ge + stam + d = gebouwd.",
          "1": "Je dacht waarschijnlijk dat het +t wordt. Maar de 'w' in 'bouw' staat NIET in 't kofschip, dus +d, niet +t. Onthoud: niet in kofschip → +d.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar na 'hebben' komt het voltooid deelwoord met ge-: gebouwd, niet bouwde. Onthoud: hebben + ge-woord.",
          "3": "Je dacht waarschijnlijk dat je ge- voor het hele werkwoord zet. Maar het voltooid deelwoord is ge + stam + d: gebouwd, niet gebouwen. Onthoud: ge + stam + t of d."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-005",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De vertaler schrijft: 'Hij heeft de brief ...' (stoppen). Welk woord past?",
      "options": ["gestopt", "gestopd", "stopte", "gestoppen"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "stoppen", "stem": "stop", "lastLetter": "p", "useTE": true, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + t (bij kofschip). De stam 'stop' eindigt op 'p' (in kofschip), dus: ge + stop + t = gestopt.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_kofschip_p",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De vertaler weet: de stam van 'stoppen' is 'stop'. De laatste letter 'p' zit WEL in 't kofschip (de P is de laatste letter!), dus: ge + stop + t = gestopt.",
        "solutionSteps": ["Na 'heeft' komt het voltooid deelwoord", "Stam bepalen: stoppen → stop", "Laatste letter: 'p' → WEL in kofschip → +t", "ge + stop + t = gestopt"],
        "distractorExplanations": {
          "0": "Goed! 'p' zit in kofschip → ge + stam + t = gestopt.",
          "1": "Je dacht waarschijnlijk dat het -d wordt. Maar de 'p' in 'stop' zit WEL in 't kofschip, dus +t, niet +d. Onthoud: kofschip-letter → +t.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar na 'heeft' komt het voltooid deelwoord met ge-: gestopt, niet stopte. Onthoud: heeft + ge-woord.",
          "3": "Je dacht waarschijnlijk dat je ge- voor het hele werkwoord zet. Maar het voltooid deelwoord is ge + stam + t: gestopt, niet gestoppen. Onthoud: ge + stam + t of d."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-006",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De secretaris typt: 'De leerling heeft goed ...' (luisteren). Welk woord past?",
      "options": ["geluisterd", "geluistert", "luisterde", "geluisteren"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "luisteren", "stem": "luister", "lastLetter": "r", "useTE": false, "label": "Voltooid Deelwoord" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + d (niet in kofschip). De stam 'luister' eindigt op 'r' (niet in kofschip), dus: ge + luister + d = geluisterd.", "icon": "lightbulb" } }],
      "conceptId": "past_participle_not_kofschip_r",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De secretaris weet: de stam van 'luisteren' is 'luister'. De laatste letter 'r' staat NIET in 't kofschip, dus: ge + luister + d = geluisterd.",
        "solutionSteps": ["Na 'heeft' komt het voltooid deelwoord", "Stam bepalen: luisteren → luister", "Laatste letter: 'r' → NIET in kofschip → +d", "ge + luister + d = geluisterd"],
        "distractorExplanations": {
          "0": "Goed! 'r' staat niet in kofschip → ge + stam + d = geluisterd.",
          "1": "Je dacht waarschijnlijk dat het +t wordt. Maar de 'r' in 'luister' staat NIET in 't kofschip, dus +d, niet +t. Onthoud: niet in kofschip → +d.",
          "2": "Je dacht waarschijnlijk dat de verleden tijd hier past. Maar na 'heeft' komt het voltooid deelwoord met ge-: geluisterd, niet luisterde. Onthoud: heeft + ge-woord.",
          "3": "Je dacht waarschijnlijk dat je ge- voor het hele werkwoord zet. Maar het voltooid deelwoord is ge + stam + d: geluisterd, niet geluisteren. Onthoud: ge + stam + t of d."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-007",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in het voltooid deelwoord. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De leerling heeft hard gewerkt aan zijn werkstuk. Hij heeft veel geleerd en alles netjes opgeruimd. Daarna heeft hij gefietsd naar huis.",
        "errors": [
          {
            "word": "gefietsd",
            "position": 22,
            "correction": "gefietst",
            "explanation": "De stam van 'fietsen' is 'fiets'. De laatste letter 's' staat in 't kofschip → ge + fiets + t = gefietst (niet gefietsd)."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "fietsen",
            "stem": "fiets",
            "lastLetter": "s",
            "useTE": true,
            "label": "'t Kofschip Regel"
          },
          "showWhen": "wrong"
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voltooid deelwoord + kofschip",
            "content": "Stap 1: Bepaal de stam. Stap 2: Kijk naar de laatste letter van de stam. Stap 3: Staat die in 't kofschip? → ge + stam + t. Zo niet → ge + stam + d. 'Fiets' eindigt op 's' (kofschip) → gefietst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_kofschip_error_spotting",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De enige fout is 'gefietsd'. De stam van 'fietsen' is 'fiets'. De laatste letter 's' staat in 't kofschip, dus het voltooid deelwoord krijgt +t: ge + fiets + t = gefietst. 'Gewerkt' is correct (stam 'werk', k in kofschip → +t). 'Geleerd' is correct (stam 'leer', r niet in kofschip → +d). 'Opgeruimd' is correct (stam 'ruim', m niet in kofschip → +d).",
        "solutionSteps": [
          "'Gewerkt' → stam 'werk', k in kofschip → +t ✓ (correct)",
          "'Geleerd' → stam 'leer', r niet in kofschip → +d ✓ (correct)",
          "'Opgeruimd' → stam 'ruim', m niet in kofschip → +d ✓ (correct)",
          "'Gefietsd' → stam 'fiets', s in kofschip → +t, niet +d → 'gefietst'"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-VD-KOF-008",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg 'werken' naar het voltooid deelwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "werken",
        "targetForm": "voltooid deelwoord",
        "context": "De timmerman heeft de hele dag ... (werken)",
        "finalAnswer": "gewerkt",
        "steps": [
          {
            "id": "step1",
            "prompt": "Kofschip-check op stam 'werk': eindigt het VD op -t of -d?",
            "type": "choice",
            "options": [
              { "label": "+t (k staat in 't kofschip)", "value": "t", "isCorrect": true },
              { "label": "+d (k staat niet in 't kofschip)", "value": "d", "isCorrect": false, "feedback": "De k staat WEL in 't kofschip (T-K-O-F-S-CH-I-P) → +t." }
            ]
          },
          {
            "id": "step2",
            "prompt": "Vul in: De timmerman heeft de hele dag ...",
            "type": "input",
            "acceptedAnswers": ["gewerkt"]
          }
        ]
      },
      "stimulusAids": [
        { "type": "kofschipMnemonic", "data": { "verb": "werken", "stem": "werk", "lastLetter": "k", "useTE": true, "label": "Voltooid Deelwoord" } }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "VD + kofschip in 2 stappen",
            "content": "Stap 1: Stam van 'werken' = 'werk'. Stap 2: Laatste letter 'k' → staat in 't kofschip → +t. Resultaat: ge + werk + t = gewerkt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_kofschip_flow",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stap 1: stam = 'werk'. Stap 2: laatste letter 'k' zit in 't kofschip → +t. Voltooid deelwoord: ge + werk + t = gewerkt.",
        "solutionSteps": [
          "Stam bepalen: werken → werk",
          "Laatste letter 'k' → staat in 't kofschip → +t",
          "ge + werk + t = gewerkt"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-wrong-ending", "label": "+d gekozen terwijl stam in kofschip eindigt" }
        ]
      }
    }
  ]
}